import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";

export const FAQ = ({ content }) => {
  const section = content.faqSection;
  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 lg:py-32">
      <div className="max-w-3xl mx-auto px-5 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-14"
        >
          <span className="section-kicker justify-center mb-4">{section.kicker}</span>
          <h2 className="font-display font-bold text-4xl sm:text-5xl">{section.title}</h2>
        </motion.div>

        <Accordion type="single" collapsible className="space-y-3">
          {section.items.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="glass rounded-lg border border-white/10 px-5"
            >
              <AccordionTrigger className="text-left hover:no-underline py-5 text-white hover:text-brand">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-white/60 leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
